import { View, Text, RadioGroup, Label, YStack } from 'tamagui'
import { QuestionWrapper } from './QuestionWrapper'

interface IOption {
  id: string
  text: string
}

interface IMultipleChoiceQuestionProps {
  options: IOption[]
  statement?: string
  selectedValue?: string
  onSelect: (value: string) => void
}

export function MultipleChoiceQuestion({
  options,
  statement,
  selectedValue,
  onSelect,
}: IMultipleChoiceQuestionProps) {
  return (
    <View>
      {statement && (
        <View
          backgroundColor="$neutral-100"
          borderRadius="$border-radius-sm"
          p="$spacing-inset-xs"
          mb="$spacing-inset-xs"
        >
          <Text color="$neutral-700" fontSize="$font-size-sm">
            {statement}
          </Text>
        </View>
      )}

      <RadioGroup
        name="multiple-choice"
        onValueChange={onSelect}
        value={selectedValue}
      >
        <YStack gap="$spacing-inset-nano">
          {options.map((option) => (
            <QuestionWrapper
              key={option.id}
              isSelected={selectedValue === option.id}
            >
              <View flexDirection="row" alignItems="center">
                <RadioGroup.Item
                  value={option.id}
                  id={option.id}
                  borderColor="$neutral-200"
                  backgroundColor={
                    selectedValue === option.id ? '$primary-300' : 'transparent'
                  }
                  size={'$spacing-lg'}
                >
                  <RadioGroup.Indicator
                    borderWidth={1}
                    w={8}
                    h={8}
                    borderColor={
                      selectedValue === option.id
                        ? '$primary-300'
                        : '$neutral-300'
                    }
                    backgroundColor={
                      selectedValue === option.id
                        ? '$neutral-100'
                        : 'transparent'
                    }
                  />
                </RadioGroup.Item>
                <Label
                  color="$neutral-800"
                  fontFamily="$mulishRegular"
                  size={'$font-size-xxs'}
                  htmlFor={option.id}
                  p="$spacing-inset-xs"
                >
                  {option.text}
                </Label>
              </View>
            </QuestionWrapper>
          ))}
        </YStack>
      </RadioGroup>
    </View>
  )
}
